// extracted by mini-css-extract-plugin
export default {"container":"Box_container__B1NW4"};